import * as Actions from "./constants";
import { put, call, takeEvery, all } from "redux-saga/effects";
import {
  getAllCompanies,
  getAllFeatures,
  createSubscription,
  getAllSubscription,
  deletePlan,
  editPlan,
  updatePlan,
  getAllSubFeatures,
  updateVisibilityStatus,
} from "../subscriptionAdmin/service";
/**
 * Create Plan
 */
function* createPlan({ postData }) {
  try {
    const { data } = yield call(createSubscription, postData);
    yield put({
      type: Actions.CREATE_SUBSCRIPTION_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: Actions.CREATE_SUBSCRIPTION_ERROR,
      error: error,
    });
  }
}
/**
 * Load all masters
 */
function* loadMaster() {
  try {
    const { companies, features, subFeatures } = yield all({
      companies: call(getAllCompanies),
      features: call(getAllFeatures),
      subFeatures: call(getAllSubFeatures),
    });
    yield put({
      type: Actions.GET_MASTERS_SUCCESS,
      company: companies,
      feature: features,
      subFeature: subFeatures,
    });
  } catch (error) {
    yield put({
      type: Actions.GET_MASTERS_ERROR,
      error: error,
    });
  }
}
/**
 * Load all subscription
 */
function* listAllSubscription() {
  try {
    const { data } = yield call(getAllSubscription);
    yield put({
      type: Actions.GET_ALL_SUBSCRIPTION_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: Actions.GET_ALL_SUBSCRIPTION_ERROR,
      error: error,
    });
  }
}
/**
 * Delete Plan
 */
function* deletePlans({ id }) {
  try {
    const { data } = yield call(deletePlan, id);
    yield put({
      type: Actions.DELETE_PLAN_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: Actions.DELETE_PLAN_ERROR,
      error: error,
    });
  }
}

/**
 * Edit Plan
 */
function* editPlans({ id }) {
  try {
    const { data } = yield call(editPlan, id);
    yield put({
      type: Actions.EDIT_PLAN_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: Actions.EDIT_PLAN_ERROR,
      error: error,
    });
  }
}

/**
 * Update Plan
 */
function* updatePlans({ postData }) {
  try {
    const { data } = yield call(updatePlan, postData);
    yield put({
      type: Actions.UPDATE_PLAN_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: Actions.UPDATE_PLAN_ERROR,
      error: error,
    });
  }
}

/**
 * Update visibility status
 */
function* updateVisibility({ id }) {
  try {
    const { data } = yield call(updateVisibilityStatus, id);
    yield put({
      type: Actions.UPDATE_VISIBILITY_STATUS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: Actions.UPDATE_VISIBILITY_STATUS_ERROR,
      error: error,
    });
  }
}

export default function* subscriptionAdminSaga() {
  yield takeEvery(Actions.GET_MASTERS, loadMaster);
  yield takeEvery(Actions.CREATE_SUBSCRIPTION, createPlan);
  yield takeEvery(Actions.GET_ALL_SUBSCRIPTION, listAllSubscription);
  yield takeEvery(Actions.DELETE_PLAN, deletePlans);
  yield takeEvery(Actions.EDIT_PLAN, editPlans);
  yield takeEvery(Actions.UPDATE_PLAN, updatePlans);
  yield takeEvery(Actions.UPDATE_VISIBILITY_STATUS, updateVisibility);
}
